import React from 'react';
import _ from 'lodash';
import async from 'async';

import './ReportPanel.scss';
import ImageButtons from './ImageButtons';
import DisplaySettings from './DisplaySettings/DisplaySettings';
import WidgetCard from './WidgetCard/WidgetCard';
import WidgetSettings from './WidgetSettings/WidgetSettings';
import WidgetFilters from './WidgetSettings/WidgetFilters';
import InlineEdit from '../InlineEdit/InlineEdit';
import WidgetThumbnails from '../../assets/WidgetThumbnails';
import axios from '../../lib/AxiosInstance';
import ScoreSettings from './ScoreSettings';
import reducerStore from '../../reducers/reducerStore';
import { SketchPicker } from 'react-color';
import InputRange from 'react-input-range';
import moment from 'moment';

class ReportPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            customWidgets: [],
            widget: props.widget,
            segments: [],
            reportTypes: {
                sales: [
                    {
                        title: 'Datum då försäljning blev 100%',
                        description: 'Försäljning: Datum då försäljning blev 100%',
                        short: 'försäljning',
                        baseShort: '',
                        value: 'closedSales',
                        settings: ['widgetDate', 'salePhase', 'products', 'grouping'],
                        filters: ['period', 'users'],
                    },
                    {
                        title: 'Avslutsdatum',
                        description: 'Försäljning: Avslutsdatum',
                        short: 'försäljning',
                        baseShort: '',
                        value: 'sales',
                        settings: ['widgetDate', 'salePhase', 'products', 'grouping'],
                        filters: ['period', 'users'],
                    },
                ],
                opportunities: [
                    {
                        title: 'Avslutsdatum',
                        description: 'Affärsmöjligheter: Avslutsdatum',
                        short: 'affärsmöjligheter avslutade',
                        baseShort: '',
                        value: 'opportunities',
                        settings: ['widgetDate', 'opportunityPhase', 'products', 'grouping'],
                        filters: ['period', 'users'],
                    },
                    {
                        title: 'När affärsmöjlighet skapats',
                        description: 'Affärsmöjligheter: Skapade',
                        short: 'affärsmöjligheter skapade',
                        baseShort: '',
                        value: 'createdOpportunities',
                        settings: ['widgetDate', 'opportunityPhase', 'products', 'grouping'],
                        filters: ['period', 'users'],
                    },
                ],
                activities: [
                    {
                        title: 'När aktivitet skapats',
                        description: 'Aktiviteter: Skapade',
                        short: 'aktiviteter',
                        baseShort: '',
                        value: 'createdActivities',
                        settings: ['widgetDate', 'activities', 'grouping'],
                        filters: ['period', 'users'],
                    },
                    {
                        title: 'När aktivitets genomförts',
                        description: 'Aktiviteter: Genomförda',
                        short: 'aktiviteter',
                        baseShort: '',
                        value: 'completedActivities',
                        settings: ['widgetDate', 'activities', 'grouping'],
                        filters: ['period', 'users'],
                    },
                    {
                        title: 'När aktivitets planerats',
                        description: 'Aktiviteter: Planerade',
                        short: 'aktiviteter',
                        baseShort: '',
                        value: 'planedActivities',
                        settings: ['widgetDate', 'activities', 'grouping'],
                        filters: ['period', 'users'],
                    },
                ],
                meetings: [
                    {
                        title: 'När mötet bokades',
                        description: 'Möten: Bokade',
                        short: 'möten',
                        baseShort: '',
                        value: 'meetings',
                        settings: ['widgetDate', 'appointment', 'grouping'],
                        filters: ['period', 'users'],
                    },
                    {
                        title: 'När mötet genomfördes',
                        description: 'Möten: Genomförda',
                        short: 'möten',
                        baseShort: '',
                        value: 'completedMeetings',
                        settings: ['widgetDate', 'appointment', 'grouping'],
                        filters: ['period', 'users'],
                    },
                    {
                        title: 'När mötet planerats',
                        description: 'Möten: Planerade',
                        short: 'möten',
                        baseShort: '',
                        value: 'planedMeetings',
                        settings: ['widgetDate', 'appointment', 'grouping'],
                        filters: ['period', 'users'],
                    },
                ],
                saleCall: [
                    {
                        title: 'telefonsamtal',
                        description: 'Telefonsamtal',
                        short: 'telefonsamtal',
                        baseShort: '',
                        value: 'saleCall',
                        settings: [],
                        filters: ['period', 'users'],
                    },
                ],
                competition: [
                    {
                        title: 'Säljtävling',
                        description: 'Säljtävling',
                        short: 'en tävling',
                        baseShort: '',
                        value: 'saleCompetition',
                        settings: ['name', 'goals', 'duration', 'users'],
                        filters: [],
                    },
                ],
                visits: [
                    {
                        title: 'Antal besök',
                        description: 'Visningar: Antal',
                        short: 'visningar',
                        baseShort: '',
                        value: 'totalVisits',
                        settings: ['widgetShows', 'visitPages'],
                        filters: ['pastPeriod'],
                    },
                    {
                        title: 'Leadskällor topplista',
                        description: 'Visningar: Top lead source',
                        short: 'visningar',
                        baseShort: '',
                        value: 'topLeadSourceVisits',
                        settings: ['widgetShows', 'visitPages'],
                        filters: ['pastPeriod'],
                    },
                    {
                        title: 'Mest besökta sidorna',
                        description: 'Visningar: Mest besökta sidorna',
                        short: 'mest besökta sidorna',
                        baseShort: '',
                        value: 'topViewsVisits',
                        settings: ['widgetShows', 'visitPages'],
                        filters: ['pastPeriod'],
                    },
                ],
                forms: [
                    {
                        title: 'Formulär',
                        description: 'Formulär',
                        short: 'formulär',
                        baseShort: '',
                        value: 'forms',
                        settings: ['forms'],
                        filters: ['pastPeriod', 'formType'],
                    }
                ],
                campaigns: [
                    {
                        title: 'Skickade email',
                        description: 'Emailkampanjer: Skickade email',
                        short: 'skickade email',
                        baseShort: '',
                        value: 'emailSent',
                        settings: ['widgetShows', 'campaigns'],
                        filters: ['pastPeriod'],
                    },
                    {
                        title: 'Öppnade/klickade email',
                        description: 'Emailkampanjer: Öppnade/klickade email',
                        short: 'öppnade/klickade email',
                        baseShort: '',
                        value: 'open/clicked',
                        settings: ['widgetShows', 'campaigns'],
                        filters: ['pastPeriod'],
                    },
                ],
            },
        };

        _.forEach(props.reports.custom, c => {
            this.state.customWidgets.push(c);
            this.state.reportTypes[c.id] = [
                {
                    value: 'custom',
                    title: c.name,
                    description: 'Egendefinierad widget',
                    short: 'en egendefinierad widget',
                    settings: [],
                    filters: [],
                }
            ];
        });

        this.dividers = [
            {
                title: 'Total',
                value: 'total',
                short: '',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                    'bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings',
                    'createdActivities', 'activities', 'planedActivities', 'completedActivities',
                ],
            },
            {
                title: 'Användare',
                value: 'user',
                short: 'per användare',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                    'bookedMeetings', 'meetings',
                    'completedMeetings', 'planedMeetings', 'saleCall',
                    'createdActivities', 'activities', 'planedActivities', 'completedActivities'
                ],
            },
            {
                title: 'Roll',
                value: 'user.role',
                short: 'på roller',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                    'bookedMeetings', 'meetings',
                    'completedMeetings', 'planedMeetings',
                    'createdActivities', 'activities', 'planedActivities', 'completedActivities'
                ],
            },
            {
                title: 'Produkt',
                value: 'product',
                short: 'på produkter',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                ]
            },
            {
                title: 'Produktkategori',
                value: 'product.category',
                short: 'på produktkategorier',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                ]
            },
            /*{
                title: 'Kund',
                value: 'client',
                availability: ['closedSales', 'sales'],
            },
            {
                title: 'Kampanj',
                value: 'project',
                availability: ['closedSales', 'sales'],
            },
            */
        ];

        this.displayTypes = [
            {
                title: 'Siffra med budget',
                value: 'NumberWidgetBar',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                    'bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings',
                    'createdActivities', 'activities', 'planedActivities', 'completedActivities',
                    'open/clicked',
                ],
                divideAvailability: ['total', 'UNDIVIDED'],
            },
            {
                title: 'Siffra',
                value: 'NumberWidget',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                    'forms',
                    'totalVisits',
                    'emailSent',
                ],
                divideAvailability: ['total', 'UNDIVIDED'],
            },
            {
                title: 'Siffra med budget rund',
                value: 'NumberWidgetCircular',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                    'bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings',
                    'createdActivities', 'activities', 'planedActivities', 'completedActivities',
                ],
                divideAvailability: ['total'],
            },
            {
                title: 'Diagram',
                value: 'ColumnChartWidget',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                    'bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings',
                    'createdActivities', 'activities', 'planedActivities', 'completedActivities',
                    'saleCall'
                ],
                divideAvailability: ['total', 'user', 'user.role', 'product', 'product.category'],
            },
            {
                title: 'Tabell',
                value: 'ColumnTableWidget',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                    'activities', 'planedActivities', 'completedActivities', 'createdActivities',
                    'bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings',
                    'forms',
                    'topLeadSourceVisits', 'topViewsVisits', 'saleCall'
                ],
                divideAvailability: ['user', 'user.role', 'product', 'product.category', 'UNDIVIDED'],
            },
            {
                title: 'Siffra med budget, halvcirkel',
                value: 'NumberWidgetHalfCircular',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                    'bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings',
                    'createdActivities', 'activities', 'planedActivities', 'completedActivities',
                ],
                divideAvailability: ['total'],
            },
            {
                title: 'Pie chart',
                value: 'PieChart',
                availability: [
                    'closedSales', 'sales',
                    'opportunities', 'createdOpportunities',
                    'bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings',
                    'createdActivities', 'activities', 'planedActivities', 'completedActivities',
                ],
                divideAvailability: ['total', 'user', 'user.role', 'product', 'product.category'],
            },
            /*
            {
                title: 'Line chart',
                value: 'LineChart',
                availability: ['closedSales'],
                divideAvailability: ['total'],
            },
            {
                title: 'Diagram med grupper',
                value: 'ColumnChartWidgetGroup',
                availability: ['sales'],
                divideAvailability: ['user'],
            },
            */
        ];

        this.periods = [
            {
                title: 'Innevarande vecka',
                short: 'innevarande vecka',
                value: 'currentWeek',
            },
            {
                title: 'Nästa vecka',
                short: 'nästa vecka',
                value: 'nextWeek',
            },
            {
                title: 'Innevarande månad',
                short: 'innevarande månad',
                value: 'currentMonth',
            },
            {
                title: 'Innevarande kvartal',
                short: 'innevarande kvartal',
                value: 'currentQuarter',
            },
            {
                title: 'Innevarande år',
                short: 'innevarande år',
                value: 'currentYear',
            },
            {
                title: 'Idag',
                short: 'idag',
                value: 'today',
            },
            {
                title: 'Senaste 7 dagarna',
                short: 'senaste 7 dagarna',
                value: 'lastSevenDays'
            },
            {
                title: 'Senaste 30 dagarna',
                short: 'senaste 30 dagarna',
                value: 'lastThirtyDays'
            },
            {
                title: 'Senaste 90 dagarna',
                short: 'senaste 90 dagarna',
                value: 'lastNinetyDays'
            },
            {
                title: 'Eget tidsspann',
                short: null,
                value: 'custom',
            },
        ];

        this.formTypes = [
            {
                title: 'Alla',
                value: 'all',
            },
            {
                title: 'Formulär',
                value: 'form',
            },
            {
                title: 'Landningssida',
                value: 'landingPage',
            },
        ];

        this.setWidgetFieldValueWrapper = this.setWidgetFieldValueWrapper.bind(this);
        this.changeWidgetType = this.changeWidgetType.bind(this);
        this.setDropdownValue = this.setDropdownValue.bind(this);

    }

    componentWillMount() {
        if (this.props.widget.type !== 'competition') {
            this.setWidgetDataType(this.props.widget);
        }
    }

    componentWillUpdate(nextProps, nextState) {
        const { widget } = nextProps;

        if (widget.type === 'competition') {
            return;
        }

        const startDate = moment(widget.dataConfig.startDate);
        const endDate = moment(widget.dataConfig.endDate);
        if (startDate.isAfter(endDate)) {
            this.setWidgetFieldValueWrapper('dataConfig.endDate', startDate.format('YYYY-MM-DD'));
        }
    }

    setWidgetDataType(widget) {
        const { widgetType, dataType } = widget;
        if (!widgetType || !dataType) {
            const newWidgetType = _.findKey(this.state.reportTypes,
                (type) => _(type).map('value').value().includes(dataType));
            const newDataType = _.get(this.state.reportTypes, [widgetType, 0, 'value']);

            let newWidget = Object.assign({}, widget, { widgetType: widgetType || newWidgetType, dataType: dataType || newDataType });
            if (_.includes(_.map(this.state.customWidgets, 'id'), widgetType)) {
                newWidget.dataConfig.endpoint = _.find(this.state.customWidgets, (c) => c.id === newWidget.widgetType).target;
            } else if (newWidget.dataType === 'custom') {
                newWidget.widgetType = _.find(this.state.customWidgets, (c) => c.target === widget.dataConfig.endpoint).id;
            } else if (_.includes(['forms', 'visits', 'custom', 'campaigns'], newWidget.widgetType)) {
                // Dont use .dataConfig.dividedBy
                newWidget.dataConfig.dividedBy = 'UNDIVIDED';
            } else if (newWidget.widgetType === 'saleCall') {
                newWidget.dataConfig.dividedBy = 'user';
            }

            const displayType = _.find(this.displayTypes, t => t.value === newWidget.displayType) ||
                _.find(this.displayTypes, t => t.availability.includes(newDataType));

            if (displayType && (!displayType.availability.includes(newWidget.dataType) ||
                !displayType.divideAvailability.includes(newWidget.dataConfig.dividedBy) ||
                !newWidget.displayType)) {
                const newDisplayType = _.find(this.displayTypes, (type) => type.availability.includes(newWidget.dataType));
                newWidget.displayType = _.get(newDisplayType, 'value');
            }

            this.props.onChange(newWidget);
        }
    }

    // Special handler for making sure that the type of data and widget type matches.
    setWidgetFieldValueWrapper(field, value) {
        const { setWidgetFieldValue, widget } = this.props;

        if (field === 'dataType') {
            const currentWidgetType = _.find(this.displayTypes, ['value', widget.displayType]);

            if (!currentWidgetType.availability.includes(value)) {
                const validDisplayType = _.find(this.displayTypes, option =>
                    option.availability.includes(value) &&
                    option.divideAvailability.includes(widget.dataConfig.dividedBy));

                setWidgetFieldValue('displayType', _.get(validDisplayType, 'value', 'NumberWidgetBar'));
            }

            const currentDivideType = _.find(this.dividers, ['value', widget.dataConfig.dividedBy]);

            if (currentDivideType && !currentDivideType.availability.includes(value)) {
                const validDivideType = _.find(this.dividers, option =>
                    option.availability.includes(value));

                setWidgetFieldValue('dataConfig.dividedBy', _.get(validDivideType, 'value', 'total'));
            }
        } else if (field === 'dataConfig.dividedBy') {
            const currentWidgetType = _.find(this.displayTypes, ['value', widget.displayType]);

            if (!currentWidgetType.divideAvailability.includes(value)) {
                const validDisplayType = _.find(this.displayTypes, option =>
                    option.availability.includes(widget.dataType) &&
                    option.divideAvailability.includes(value));

                setWidgetFieldValue('displayType', validDisplayType.value);
            }
        }

        setWidgetFieldValue(field, value);
    }

    changeWidgetType(widgetType) {
        const dataType = _.get(this.state.reportTypes, [widgetType, 0, 'value']);
        const currentWidgetType = _.find(this.displayTypes, ['value', this.props.widget.displayType]);
        const dividedBy = _.find(this.dividers, (d) => d.availability.includes(dataType));

        const displayType = (_.get(currentWidgetType, 'availability', []).includes(dataType) &&
            _.get(currentWidgetType, 'divideAvailability', []).includes('total')) ?
            currentWidgetType :
            _.find(this.displayTypes, (type) => type.availability.includes(dataType));

        const endpoint = _.get(_.find(this.state.customWidgets, (c) => c.id === widgetType), 'target');
        const newWidget = Object.assign({}, this.props.widget, {
            widgetType,
            dataType,
            displayConfig: null,
            displayType: _.get(displayType, 'value', ''),
            dataConfig: Object.assign({}, this.props.widget.dataConfig, { dividedBy: _.get(dividedBy, 'value', 'UNDIVIDED'), endpoint })
        });
        this.props.onChange(newWidget);
    }

    renderReportCards(arr) {
        return arr.map((item, index) => (
            <WidgetCard
                key={`${item.id}-${index}`}
                item={item}
                onClick={this.changeWidgetType}
                active={this.props.widget.widgetType === item.id}
            />
        ));
    }

    getWidgetThumbnail(widgetType) {
        const widgetIcon = WidgetThumbnails[widgetType];
        if (!widgetIcon) return widgetType;
        return widgetIcon();
    };

    addNewCriteria(editingSlide, isNew) {
        let newId;
        let currentState = reducerStore.getState();

        currentState.slides.forEach(slide => {
            if (slide.type === 'competition' && slide.id === editingSlide && !isNew) {
                newId = slide.competitionSettings.criterias.length;
            } else if (slide.type === 'competition' && !slide.id && isNew) {
                newId = slide.competitionSettings.criterias.length;
            }
        });

        if (newId > 7) {
            return;
        }

        reducerStore.dispatch({ type: 'ADD_COMPETITION_CRITERIA', value: newId, slideId: editingSlide, isNew: isNew });
    }

    setDropdownValue(value, index, panel, slideId) {
        //if value is Sales/Opportunity set the status to empty string
        if (value === 'Sales' || value === "Opportunity") {
            reducerStore.dispatch({ type: 'UPDATE_COMPETITION_CRITERIA', property: 'status', value: '', index: index, slideId: slideId, isNew: this.props.isNew });
        }

        //transitioning between activity and appointment 
        //does not match the status as they are different texts
        if (panel.type != value && (value === 'Activity' || value === 'Appointment')) {
            reducerStore.dispatch({ type: 'UPDATE_COMPETITION_CRITERIA', property: 'status', value: 'All', index: index, slideId: slideId, isNew: this.props.isNew });
        }

        reducerStore.dispatch({ type: 'UPDATE_COMPETITION_CRITERIA', property: 'type', value: value, index: index, slideId: slideId, isNew: this.props.isNew });
    }

    bgColorChange(color, slide) {
        slide.custom.bgColor = color;
        this.updateSlide(slide);
    }

    updateSlide(slide) {
        reducerStore.dispatch({ type: 'UPDATE SLIDES', freshSlides: slide });
    }

    // Returns black or white depending on the provided color
    getTextColor(_hex) {
        let hex = _hex.substring(1);
        // We always want 6 digit hex
        if (hex.length === 3) {
            hex = `${hex}${hex}`;
        }

        const rgb = parseInt(hex, 16);   // convert rrggbb to decimal
        const r = (rgb >> 16) & 0xff;  // extract red
        const g = (rgb >> 8) & 0xff;  // extract green
        const b = (rgb >> 0) & 0xff;  // extract blue

        const luma = (0.2126 * r) + (0.7152 * g) + (0.0722 * b); // per ITU-R BT.709

        if (luma < 150) {
            return '#ffffff';
        }

        return '#000000';
    }

    getDisplayColorPicker(companyProfile, slide, showPicker) {
        let displayColorPicker;
        if (showPicker) {
            displayColorPicker = (<SketchPicker
                color={slide.custom && slide.custom.bgColor ? slide.custom.bgColor : companyProfile.colors.mainBg}
                onChangeComplete={(e) => { this.bgColorChange(e.hex, slide); }}
            />);
        } else {
            displayColorPicker = (<div
                className="color-box"
                onClick={(e) => {
                    reducerStore.dispatch({ type: 'TOGGLE COLOR PICKER', open: true });
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                }}
                style={{
                    backgroundColor: slide.custom && slide.custom.bgColor ? slide.custom.bgColor : companyProfile.colors.mainBg,
                    color: this.getTextColor(slide.custom && slide.custom.bgColor ? slide.custom.bgColor : companyProfile.colors.mainBg),
                    padding: '10px 15px',
                    borderRadius: '3px',
                    display: 'inline-block',
                    width: 'auto',
                    textAlign: 'center',
                    margin: '5px 0',
                }}
            >
                {slide.custom && slide.custom.bgColor ? slide.custom.bgColor : companyProfile.colors.mainBg}
            </div>);
        }

        return displayColorPicker;
    }

    rangeSlideDragged(value, slide) {
        slide.custom.bgOpacity = value;
        this.updateSlide(slide);
    }

    rangeSlideDraggedText(value, slide) {
        slide.custom.bgOpacity = parseInt(value, 10);
        this.updateSlide(slide);
    }

    bgImageChange(value, slide) {
        slide.backgroundImage = value;
        this.updateSlide(slide);
    }

    render() {
        const { reports, widget, editingSlide, isNew } = this.props;
        if (!widget) {
            return (<div className="panel" />);
        }

        const widgetType = _.find(_.get(this.state.reportTypes, [widget.widgetType]), { value: widget.dataType });

        if (!widgetType && widget.type !== 'competition') {
            return null;
        }

        if (widget.widgetType === 'saleCall' && (widget.dataConfig.period === 'today' || widget.dataConfig.period === 'currentWeek')) {
        } else if (widget.widgetType === 'saleCall') {
            widget.dataConfig.period = 'currentWeek';
        }

        const reportType = _.findKey(reports, (t) => _.some(t, (s) => s.id === widget.widgetType));
        const dividedBy = _.find(this.dividers, { value: widget.dataConfig.dividedBy });
        const period = _.find(this.periods, { value: widget.dataConfig.period });

        //get the state from the redux store
        let competitionPanels;
        let competitionSlide;
        let currentState = reducerStore.getState();
        currentState.slides.some(slide => {
            if (slide.type === 'competition' && slide.id === editingSlide && !isNew) {
                competitionSlide = slide;
                competitionPanels = slide.competitionSettings.criterias;
                return true;
            } else if (slide.type === 'competition' && !slide.id && isNew) {
                competitionSlide = slide;
                competitionPanels = slide.competitionSettings.criterias;
                return true;
            }
        });

        let displayColorPicker;
        if (competitionSlide && widget.widgetType === 'competition') {
            displayColorPicker = this.getDisplayColorPicker(currentState.companyProfile, competitionSlide, currentState.openPicker);
        }

        return (<div className="panel">
            <div className='widget-settings'>
                <div className='widget-type'>
                    <h2>Typ av widget</h2>
                    <div className='widget-card-grid'>
                        {this.renderReportCards(reports[reportType])}
                    </div>
                    <WidgetSettings
                        widget={widget}
                        reportTypes={this.state.reportTypes}
                        setWidgetFieldValueWrapper={this.setWidgetFieldValueWrapper}
                        dividers={this.dividers}
                    />
                </div>

                {widgetType.filters.length > 0 && <div className='widget-filter'>
                    <h2>Filter</h2>
                    <WidgetFilters
                        widget={widget}
                        reportTypes={this.state.reportTypes}
                        setWidgetFieldValueWrapper={this.setWidgetFieldValueWrapper}
                        periods={this.periods}
                        formTypes={this.formTypes}
                    />
                </div>}
            </div>
            {widget.widgetType !== 'competition' && <div className="widget-appearance">
                <div className='appearance-container'>
                    <ImageButtons
                        setWidgetFieldValue={this.props.setWidgetFieldValue}
                        field={'displayType'}
                        options={this.displayTypes}
                        widget={widget}
                    />
                    <div className='widget-preview'>
                        <div className='preview-holder'>
                            {widget.dataType !== 'custom' && <div className='widget-title'>
                                <input
                                    value={_.get(widget, 'displayConfig.customTitle', '')}
                                    onChange={(event) => { this.props.setWidgetFieldValue('displayConfig.customTitle', event.target.value); }}
                                    placeholder={'Ange widgetens namn'}
                                />
                                <i className="fa fa-pencil" aria-hidden="true"></i>
                            </div>}
                            <div className='widget-thumbnail'>
                                {widgetType.value === 'custom' ?
                                    <img src="client/assets/custom-widget.png" style={{ margin: 'auto' }} /> :
                                    this.getWidgetThumbnail(widget.displayType)
                                }
                            </div>
                        </div>
                    </div>

                    <div className='widget-info'>
                        <h3>{widgetType.description}</h3>
                        <p>
                            Widgeten visar <span>{widgetType.short}</span>
                            {dividedBy && dividedBy.short ? (<text> grupperat <span>{dividedBy.short}</span></text>) : ''}
                            {period ? (<text> under perioden <span>{period.short || `${widget.dataConfig.startDate} till ${widget.dataConfig.endDate}`}</span></text>) : ''}
                            {widgetType.baseShort && <text> baserat på <span>{widgetType.baseShort}</span></text>}
                            .
                            </p>
                    </div>

                    <DisplaySettings
                        setWidgetFieldValue={this.props.setWidgetFieldValue}
                        widget={widget}
                    />
                </div>
            </div>}

            {widget.widgetType === 'competition' && competitionSlide && <div className="competition-container"
                onClick={(e) => {
                    reducerStore.dispatch({ type: 'TOGGLE COLOR PICKER', open: false });
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                }}>
                <div className="appearance-settings">
                    <span className="title">Appearance</span>

                    <div name='background-image' style={{ marginTop: '15px' }}>
                        <span className="appearance-labels">Background image link</span>
                        <div style={{ marginTop: '5px' }}>
                            <input
                                id="bgImage"
                                type="text"
                                placeholder={'Enter link to a nice image'}
                                className="form-control"
                                value={competitionSlide.backgroundImage}
                                onChange={(e) => { this.bgImageChange(e.target.value, competitionSlide) }}
                            />
                        </div>
                    </div>

                    <div name='competition-color' className="setting" style={{ marginTop: '15px', display: 'inline-block' }} >
                        <span className="appearance-labels">Competition color</span><br />
                        <div
                            style={{ display: 'inline-block', marginTop: '5px' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.nativeEvent.stopImmediatePropagation();
                            }}>
                            {displayColorPicker}
                        </div>
                    </div>

                    <div name='image-visibility' className="setting" style={{ position: "absolute", marginTop: '15px', display: 'inline-block', marginLeft: '60px' }}>
                        <div name='slider' className="opacity-group" style={{ display: 'inline-block' }}>
                            <span className="appearance-labels">Background image visibility</span>
                            <InputRange
                                minValue={0}
                                maxValue={100}
                                value={competitionSlide.custom && competitionSlide.custom.bgOpacity ? competitionSlide.custom.bgOpacity : 50}
                                onChange={(e) => { this.rangeSlideDragged(e, competitionSlide) }}
                            />
                        </div>

                        <div name='percent' style={{ position: "absolute", marginTop: '20px', marginLeft: '20px', display: 'inline-block' }}>
                            <input
                                type="text"
                                className='input input-center-aligned'
                                style={{ width: '50px' }}
                                name="opacity-value"
                                value={competitionSlide.custom && competitionSlide.custom.bgOpacity ? competitionSlide.custom.bgOpacity : 50}
                                onChange={(e) => { this.rangeSlideDraggedText(e.target.value, competitionSlide) }}
                            />
                        </div>
                    </div>

                </div> {/*appearance-setting ends*/}

                <div className="widget-appearance">
                    <span className="title">What creates score</span>
                    {competitionPanels.map((panel, index) => <ScoreSettings key={index} index={index} setValue={(value, valueIndex) => this.setDropdownValue(value, valueIndex, panel, editingSlide)} criteria={panel} slideId={editingSlide} widget={widget} isNew={isNew} />)}
                </div>
                <div className="add-criteria" onClick={() => this.addNewCriteria(editingSlide, isNew)} style={{ cursor: 'pointer' }}>
                    <i className="fa fa-plus fa-lg" style={{ color: 'rgb(107, 124, 147)', padding: '13px' }} />
                    <span>Add points criteria ({8 - competitionPanels.length} possible left)</span>
                </div>
            </div>}

        </div>
        )
    }
}

ReportPanel.propTypes = {
    setWidgetFieldValue: React.PropTypes.func,
    widget: React.PropTypes.object,
};

export default ReportPanel;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/ReportPanel.jsx
 **/